import { CRUDService } from './crud-service.class'

export class CorrectService extends CRUDService {
  subject = 'correct'
}
